export default __webpack_public_path__ + "static/media/logo_serena.5787c9da.svg";